import { render, staticRenderFns } from "./CMOverviewCourseRow.vue?vue&type=template&id=249a1b0a&scoped=true&lang=pug&"
import script from "./CMOverviewCourseRow.vue?vue&type=script&lang=js&"
export * from "./CMOverviewCourseRow.vue?vue&type=script&lang=js&"
import style0 from "./CMOverviewCourseRow.vue?vue&type=style&index=0&id=249a1b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a1b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})
